document.addEventListener("DOMContentLoaded", function() {
    var h2Elements = document.querySelectorAll('.section-heading');
  
    h2Elements.forEach(function(element) {
      var words = element.textContent.trim().split(' ');
      if (words.length >= 2) {
        words[1] = '<span class="highlighted">' + words[1] + '</span>';
        element.innerHTML = words.join(' ');
      } else if (words.length === 1) {
        var word = words[0];
        var halfIndex = Math.ceil(word.length / 2);
        var firstHalf = word.slice(0, halfIndex);
        var secondHalf = word.slice(halfIndex);
        element.innerHTML = firstHalf + '<span class="highlighted">' + secondHalf + '</span>';
      } else if (words.length > 2) {
        var word = words[0]; // Take the first word for demonstration, you may need to adjust based on your requirements
        var halfIndex = Math.ceil(word.length / 2);
        var firstHalf = word.slice(0, halfIndex);
        var secondHalf = word.slice(halfIndex);
        element.innerHTML = firstHalf + '<span class="highlighted">' + secondHalf + '</span>';
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function() {
    var h2Elements = document.querySelectorAll('.icon-sec .section-heading');
  
    h2Elements.forEach(function(element) {
      var words = element.textContent.trim().split(' ');
      if (words.length >= 3) {
        words[2] = '<span class="highlighted">' + words[2] + '</span>';
        element.innerHTML = words.join(' ');
      }
    });
  });


jQuery(window).on('load', function(){
      jQuery('.frame-description').appendTo('.cl-po--option[data-option="Frame Style"]');
      jQuery('.character-description').appendTo('.cl-po--option[data-option="How many characters?"]');     
});

// jQuery(document).ready(function () {
//     let productForm = jQuery('product-form');
//     let options = jQuery('.cl-po--option');
//     let currentIndex = 0;

//     let firstStepCount = 2;
//     let otherStepsCount = 3;

//     let specialProducts = [
//         'song-lyrics-poster-personalised-music-print-gift-custom-lyric-wall-art',
//         'personalised-song-lyric-print-custom-first-dance-wedding-gift-lyrics-framed-wall-art',
//         'personalised-vinyl-record-canvas-prints',
//         'personalised-spotify-vinyl-record-canvas-print'
//     ];

//     let currentHandle = window.location.pathname.split('/products/')[1];
//     let isSpecialProduct = specialProducts.includes(currentHandle);

//     // ✅ NEW: Detect Custom Pet Portraits collection
//     let isPetCollection = window.productCollections && 
//         window.productCollections.includes('Custom Pet Portraits');

//     function initializeScript() {
//         options = jQuery('.cl-po--option');

//         if (!options.length) {
//             console.warn('No Live Product Options found. Waiting for LPO to load...');
//             return;
//         }

//         productForm.hide();

//         let progressContainer = jQuery('<div class="progress-container"></div>');

//         function getStepRange(index) {
//             let start = 0;

//             if (index === 0) {
//                 return { start: 0, end: firstStepCount - 1 };
//             }

//             start = firstStepCount + (index - 1) * otherStepsCount;
//             let end = start + otherStepsCount - 1;

//             return { start, end };
//         }

//         function totalSteps() {
//             if (isSpecialProduct) return 3;

//             if (options.length <= firstStepCount) return 1;
//             return 1 + Math.ceil((options.length - firstStepCount) / otherStepsCount);
//         }

//         function updateProgressBar(index) {
//             jQuery('.progress-step').removeClass('active');
//             jQuery('.step-circle').removeClass('completed');

//             jQuery('.progress-step:lt(' + (index + 1) + ') .step-circle').addClass('completed');
//             jQuery(`.progress-step[data-step="${index}"]`).addClass('active');
//         }

//         function showStep(index) {
//             options.hide();

//             // 👉 SPECIAL PRODUCT LOGIC (UNCHANGED)
//             if (isSpecialProduct) {

//                 let frameColour = jQuery('.cl-po--option[data-option="Frame Colour"]');
//                 frameColour.hide();

//                 if (index === 0) {
//                     frameColour.show();
//                 }

//                 let stepOptions;

//                 if (index === 0) {
//                     stepOptions = options.filter(function () {
//                         let opt = jQuery(this).data('option');
//                         return opt === 'Frame Style' ||
//                                opt === 'Size' ||
//                                opt === 'Colourway' ||
//                                opt === 'Finish' ||
//                                opt === 'Frame Colour';
//                     });
//                 }

//                 else if (index === 1) {
//                     stepOptions = options.not(function () {
//                         let opt = jQuery(this).data('option');
//                         return opt === 'Frame Style' ||
//                                opt === 'Size' ||
//                                opt === 'Colourway' ||
//                                opt === 'Finish' ||
//                                opt === 'Frame Colour' ||
//                                opt === 'Special Request' ||
//                                opt === 'Upload Image & Special Request';
//                     });
//                 }

//                 else if (index === 2) {
//                     stepOptions = options.filter(function () {
//                         let opt = jQuery(this).data('option');
//                         return opt === 'Special Request' || opt === 'Upload Image & Special Request';
//                     });
//                 }

//                 stepOptions.show();

//                 prevBtn.toggle(index !== 0);
//                 nextBtn.toggle(index < 2);
//                 productForm.toggle(index === 2);

//                 updateProgressBar(index);
//                 return;
//             }

//             // 👉 DEFAULT LOGIC (UPDATED SAFELY)

//             let range = getStepRange(index);

//             let stepOptions = options.slice(range.start, range.end + 1);

//             // ✅ REMOVE pet options from normal flow ONLY for pet collection
//             if (isPetCollection) {
//                 stepOptions = stepOptions.filter(function() {
//                     let opt = jQuery(this).data('option');
//                     return opt !== 'pet image' && opt !== 'Special Request';
//                 });
//             }

//             if (index !== 0) {
//                 stepOptions = stepOptions.filter(function() {
//                     return jQuery(this).data('option') !== 'Frame Colour';
//                 });
//             }

//             stepOptions.show();

//             prevBtn.toggle(index !== 0);
//             nextBtn.toggle(range.end < options.length - 1);
//             productForm.toggle(range.end >= options.length - 1);

//             let frameStyleSelected = jQuery('.cl-po--option[data-option="Frame Style"] select').val();
//             let selectFrameColor = jQuery('.cl-po--option[data-option="Frame Colour"]');
//             let thickFrameOption = jQuery('.cl-po--option[data-option="Thick Frame"]');
//             let petNameOption = jQuery('.cl-po--option[data-option="pet name"]');

//             // ✅ NEW
//             let petImageOption = jQuery('.cl-po--option[data-option="pet image"]');
//             let specialRequestOption = jQuery('.cl-po--option[data-option="Special Request"]');

//             selectFrameColor.hide();
//             thickFrameOption.hide();
//             petNameOption.hide();
//             petImageOption.hide();
//             specialRequestOption.hide();

//             if (index === 0 && (frameStyleSelected === 'Framed' || frameStyleSelected === 'Frame')) {
//                 selectFrameColor.show();
//             }

//             if (index === 1 && frameStyleSelected === 'Canvas') {
//                 thickFrameOption.show();
//             }

//             if (index === totalSteps() - 1) {
//                 petNameOption.show();

//                 // ✅ ONLY for Custom Pet Portraits collection
//                 if (isPetCollection) {
//                     petImageOption.show();
//                     specialRequestOption.show();
//                 }
//             }

//             updateProgressBar(index);
//         }

//         function createProgressBarSteps() {
//             progressContainer.empty();

//             let steps = totalSteps();

//             for (let i = 0; i < steps; i++) {
//                 progressContainer.append(`
//                     <div class="progress-step" data-step="${i}">
//                         <div class="step-circle">${i + 1}</div>
//                         ${i < steps - 1 ? '<div class="step-line-horizontal"></div>' : ''}
//                     </div>
//                 `);
//             }

//             options.first().before(progressContainer);
//         }

//         let navContainer = jQuery('<div class="nav-buttons" style="display:flex; gap:10px; margin-top:10px;"></div>');

//         let prevBtn = jQuery(`
//             <button id="prevBtn" type="button" class="nav-button" style="display:none;">
//                 <img src="https://cdn.shopify.com/s/files/1/0520/9758/1215/files/back.png?v=1739793092" width="100%" height="100%" />
//             </button>
//         `);

//         let nextBtn = jQuery('<button id="nextBtn" type="button" class="nav-button" disabled>Next Step</button>');

//         navContainer.append(prevBtn, nextBtn);
//         options.last().after(navContainer);

//         jQuery(document).off('change', '.cl-po--option[data-option="Frame Style"] select');
//         jQuery(document).on('change', '.cl-po--option[data-option="Frame Style"] select', function () {
//             createProgressBarSteps();
//             currentIndex = 0;
//             showStep(currentIndex);
//         });

//         nextBtn.on('click', function () {
//             if (currentIndex < totalSteps() - 1) {
//                 currentIndex++;
//                 showStep(currentIndex);
//             }
//         });

//         prevBtn.on('click', function () {
//             if (currentIndex > 0) {
//                 currentIndex--;
//                 showStep(currentIndex);
//             }
//         });

//         jQuery(document).on('lpo:validationFailed', function () {
//             nextBtn.prop('disabled', true);
//         });

//         jQuery(document).on('lpo:validationPassed', function () {
//             nextBtn.prop('disabled', false);
//         });

//         jQuery(document).on('lpo:optionUpdated', function() {
//             showStep(currentIndex);
//         });

//         createProgressBarSteps();
//         showStep(0);

//         setInterval(function () {
//             let hasErrors = jQuery('.cl-po--errors:visible').length > 0;
//             nextBtn.prop('disabled', hasErrors);
//         }, 500);
//     }

//     function waitForLPO() {
//         let observer = new MutationObserver(function (mutationsList, observer) {
//             let optionsExist = jQuery('.cl-po--option').length > 0;

//             if (optionsExist) {
//                 console.log('LPO options detected. Initializing script...');
//                 observer.disconnect();
//                 initializeScript();
//             }
//         });

//         observer.observe(document.body, { childList: true, subtree: true });
//     }

//     waitForLPO();
// });

// jQuery(document).ready(function () {
//     let productForm = jQuery('product-form');
//     let options = jQuery('.cl-po--option');
//     let currentIndex = 0;

//     let firstStepCount = 2;
//     let otherStepsCount = 3;

//     let specialProducts = [
//         'song-lyrics-poster-personalised-music-print-gift-custom-lyric-wall-art',
//         'personalised-song-lyric-print-custom-first-dance-wedding-gift-lyrics-framed-wall-art',
//         'personalised-vinyl-record-canvas-prints',
//         'personalised-spotify-vinyl-record-canvas-print'
//     ];

//     let currentHandle = window.location.pathname.split('/products/')[1];
//     let isSpecialProduct = specialProducts.includes(currentHandle);

//     // Detect Custom Pet Portraits collection
//     let isPetCollection = window.productCollections && 
//         window.productCollections.includes('Custom Pet Portraits');

//     function initializeScript() {
//         options = jQuery('.cl-po--option');

//         if (!options.length) {
//             console.warn('No Live Product Options found. Waiting for LPO to load...');
//             return;
//         }

//         productForm.hide();

//         let progressContainer = jQuery('<div class="progress-container"></div>');

//         function getStepRange(index) {
//             let start = 0;

//             if (index === 0) {
//                 return { start: 0, end: firstStepCount - 1 };
//             }

//             start = firstStepCount + (index - 1) * otherStepsCount;
//             let end = start + otherStepsCount - 1;

//             return { start, end };
//         }

//         function totalSteps() {
//             if (isSpecialProduct) return 3;

//             if (options.length <= firstStepCount) return 1;
//             return 1 + Math.ceil((options.length - firstStepCount) / otherStepsCount);
//         }

//         function updateProgressBar(index) {
//             jQuery('.progress-step').removeClass('active');
//             jQuery('.step-circle').removeClass('completed');

//             jQuery('.progress-step:lt(' + (index + 1) + ') .step-circle').addClass('completed');
//             jQuery(`.progress-step[data-step="${index}"]`).addClass('active');
//         }

//         function showStep(index) {
//             options.hide();

//             // SPECIAL PRODUCT LOGIC
//             if (isSpecialProduct) {

//                 let frameColour = jQuery('.cl-po--option[data-option="Frame Colour"]');
//                 frameColour.hide();

//                 if (index === 0) {
//                     frameColour.show();
//                 }

//                 let stepOptions;

//                 if (index === 0) {
//                     stepOptions = options.filter(function () {
//                         let opt = jQuery(this).data('option');
//                         return opt === 'Frame Style' ||
//                                opt === 'Size' ||
//                                opt === 'Colourway' ||
//                                opt === 'Finish' ||
//                                opt === 'Frame Colour';
//                     });
//                 }

//                 else if (index === 1) {
//                     stepOptions = options.not(function () {
//                         let opt = jQuery(this).data('option');
//                         return opt === 'Frame Style' ||
//                                opt === 'Size' ||
//                                opt === 'Colourway' ||
//                                opt === 'Finish' ||
//                                opt === 'Frame Colour' ||
//                                opt === 'Special Request' ||
//                                opt === 'Upload Image & Special Request';
//                     });
//                 }

//                 else if (index === 2) {
//                     stepOptions = options.filter(function () {
//                         let opt = jQuery(this).data('option');
//                         return opt === 'Special Request' || opt === 'Upload Image & Special Request';
//                     });
//                 }

//                 stepOptions.show();

//                 prevBtn.toggle(index !== 0);
//                 nextBtn.toggle(index < 2);
//                 productForm.toggle(index === 2);

//                 updateProgressBar(index);
//                 return;
//             }

//             // DEFAULT LOGIC

//             let range = getStepRange(index);
//             let stepOptions = options.slice(range.start, range.end + 1);

//             // Remove pet options from normal flow ONLY for pet collection
//             if (isPetCollection) {
//                 stepOptions = stepOptions.filter(function() {
//                     let opt = jQuery(this).data('option');
//                     return opt !== 'pet image' && opt !== 'Special Request';
//                 });
//             }

//             if (index !== 0) {
//                 stepOptions = stepOptions.filter(function() {
//                     return jQuery(this).data('option') !== 'Frame Colour';
//                 });
//             }

//             stepOptions.show();

//             prevBtn.toggle(index !== 0);
//             nextBtn.toggle(range.end < options.length - 1);
//             productForm.toggle(range.end >= options.length - 1);

//             let frameStyleSelected = jQuery('.cl-po--option[data-option="Frame Style"] select').val();
//             let selectFrameColor = jQuery('.cl-po--option[data-option="Frame Colour"]');
//             let thickFrameOption = jQuery('.cl-po--option[data-option="Thick Frame"]');
//             let petNameOption = jQuery('.cl-po--option[data-option="pet name"]');

//             // UPDATED (safe selector optional)
//             let petImageOption = jQuery('.cl-po--option[data-option="pet image"]');
//             let specialRequestOption = jQuery('.cl-po--option').filter(function() {
//                 return jQuery(this).data('option')?.toLowerCase().includes('special request');
//             });

//             selectFrameColor.hide();
//             thickFrameOption.hide();
//             petNameOption.hide();
//             petImageOption.hide();
//             specialRequestOption.hide();

//             if (index === 0 && (frameStyleSelected === 'Framed' || frameStyleSelected === 'Frame')) {
//                 selectFrameColor.show();
//             }

//             if (index === 1 && frameStyleSelected === 'Canvas') {
//                 thickFrameOption.show();
//             }

//             // ✅ FIX APPLIED HERE
//             if (index === totalSteps() - 1) {
//                 petNameOption.show();

//                 // ALWAYS show Special Request
//                 specialRequestOption.show();

//                 // ONLY for pet collection
//                 if (isPetCollection) {
//                     petImageOption.show();
//                 }
//             }

//             updateProgressBar(index);
//         }

//         function createProgressBarSteps() {
//             progressContainer.empty();

//             let steps = totalSteps();

//             for (let i = 0; i < steps; i++) {
//                 progressContainer.append(`
//                     <div class="progress-step" data-step="${i}">
//                         <div class="step-circle">${i + 1}</div>
//                         ${i < steps - 1 ? '<div class="step-line-horizontal"></div>' : ''}
//                     </div>
//                 `);
//             }

//             options.first().before(progressContainer);
//         }

//         let navContainer = jQuery('<div class="nav-buttons" style="display:flex; gap:10px; margin-top:10px;"></div>');

//         let prevBtn = jQuery(`
//             <button id="prevBtn" type="button" class="nav-button" style="display:none;">
//                 <img src="https://cdn.shopify.com/s/files/1/0520/9758/1215/files/back.png?v=1739793092" width="100%" height="100%" />
//             </button>
//         `);

//         let nextBtn = jQuery('<button id="nextBtn" type="button" class="nav-button" disabled>Next Step</button>');

//         navContainer.append(prevBtn, nextBtn);
//         options.last().after(navContainer);

//         jQuery(document).off('change', '.cl-po--option[data-option="Frame Style"] select');
//         jQuery(document).on('change', '.cl-po--option[data-option="Frame Style"] select', function () {
//             createProgressBarSteps();
//             currentIndex = 0;
//             showStep(currentIndex);
//         });

//         nextBtn.on('click', function () {
//             if (currentIndex < totalSteps() - 1) {
//                 currentIndex++;
//                 showStep(currentIndex);
//             }
//         });

//         prevBtn.on('click', function () {
//             if (currentIndex > 0) {
//                 currentIndex--;
//                 showStep(currentIndex);
//             }
//         });

//         jQuery(document).on('lpo:validationFailed', function () {
//             nextBtn.prop('disabled', true);
//         });

//         jQuery(document).on('lpo:validationPassed', function () {
//             nextBtn.prop('disabled', false);
//         });

//         jQuery(document).on('lpo:optionUpdated', function() {
//             showStep(currentIndex);
//         });

//         createProgressBarSteps();
//         showStep(0);

//         setInterval(function () {
//             let hasErrors = jQuery('.cl-po--errors:visible').length > 0;
//             nextBtn.prop('disabled', hasErrors);
//         }, 500);
//     }

//     function waitForLPO() {
//         let observer = new MutationObserver(function (mutationsList, observer) {
//             let optionsExist = jQuery('.cl-po--option').length > 0;

//             if (optionsExist) {
//                 console.log('LPO options detected. Initializing script...');
//                 observer.disconnect();
//                 initializeScript();
//             }
//         });

//         observer.observe(document.body, { childList: true, subtree: true });
//     }

//     waitForLPO();
// });

jQuery(document).ready(function () {

    let productForm = jQuery('product-form');
    let options = jQuery('.cl-po--option');
    let currentIndex = 0;

    let firstStepCount = 2;
    let otherStepsCount = 3;

    let specialProducts = [
        'song-lyrics-poster-personalised-music-print-gift-custom-lyric-wall-art',
        'personalised-song-lyric-print-custom-first-dance-wedding-gift-lyrics-framed-wall-art',
        'personalised-vinyl-record-canvas-prints',
        'personalised-spotify-vinyl-record-canvas-print'
    ];

    // Products where step 2 should contain 4 options
    let fourOptionStep2Products = [
        'dog-paw-photo-print-custom-dog-gift-dog-memorial-poster-personalised-pet-print-couple-gift-doggy-keepsake-dog-lover-gift-pet-memory',
        'custom-dog-memorial-photo-collage-print-pet-loss-gift-rainbow-bridge-tribute-personalised-dog-paw-print-poster-pet-remembrance-gift',
        'personalised-cat-memorial-photo-collage-cat-paw-print-gift-canvas-framed-prints',
        'personalised-fathers-day-dog-photo-print-dog-paw-print-poster-gift-for-dog-dad-from-dog'
    ];

    let currentHandle = window.location.pathname.split('/products/')[1];

    let isSpecialProduct = specialProducts.includes(currentHandle);

    let isFourOptionStep2Product = fourOptionStep2Products.includes(currentHandle);

    // Detect Custom Pet Portraits collection
    let isPetCollection = window.productCollections &&
        window.productCollections.includes('Custom Pet Portraits');

    function initializeScript() {

        options = jQuery('.cl-po--option');

        if (!options.length) {

            console.warn('No Live Product Options found. Waiting for LPO to load...');

            return;
        }

        productForm.hide();

        let progressContainer = jQuery('<div class="progress-container"></div>');

        function getStepRange(index) {

            let start = 0;

            if (index === 0) {

                return {
                    start: 0,
                    end: firstStepCount - 1
                };
            }

            start = firstStepCount + (index - 1) * otherStepsCount;

            let end = start + otherStepsCount - 1;

            return {
                start,
                end
            };
        }

        function totalSteps() {

            // Fixed steps for special products
            if (isSpecialProduct) return 3;

            // Custom product with dedicated upload step
            if (isFourOptionStep2Product) return 3;

            if (options.length <= firstStepCount) return 1;

            return 1 + Math.ceil((options.length - firstStepCount) / otherStepsCount);
        }

        function updateProgressBar(index) {

            jQuery('.progress-step').removeClass('active');

            jQuery('.step-circle').removeClass('completed');

            jQuery('.progress-step:lt(' + (index + 1) + ') .step-circle').addClass('completed');

            jQuery(`.progress-step[data-step="${index}"]`).addClass('active');
        }

        function showStep(index) {

            options.hide();

            // =========================================================
            // SPECIAL PRODUCTS
            // =========================================================

            if (isSpecialProduct) {

                let frameColour = jQuery('.cl-po--option[data-option="Frame Colour"]');

                frameColour.hide();

                if (index === 0) {
                    frameColour.show();
                }

                let stepOptions;

                if (index === 0) {

                    stepOptions = options.filter(function () {

                        let opt = jQuery(this).data('option');

                        return opt === 'Frame Style' ||
                            opt === 'Size' ||
                            opt === 'Colourway' ||
                            opt === 'Finish' ||
                            opt === 'Frame Colour';
                    });

                } else if (index === 1) {

                    stepOptions = options.not(function () {

                        let opt = jQuery(this).data('option');

                        return opt === 'Frame Style' ||
                            opt === 'Size' ||
                            opt === 'Colourway' ||
                            opt === 'Finish' ||
                            opt === 'Frame Colour' ||
                            opt === 'Special Request' ||
                            opt === 'Upload Image & Special Request';
                    });

                } else if (index === 2) {

                    stepOptions = options.filter(function () {

                        let opt = jQuery(this).data('option');

                        return opt === 'Special Request' ||
                            opt === 'Upload Image & Special Request';
                    });
                }

                stepOptions.show();

                prevBtn.toggle(index !== 0);

                nextBtn.toggle(index < 2);

                productForm.toggle(index === 2);

                updateProgressBar(index);

                return;
            }

            // =========================================================
            // CUSTOM 4 OPTION PRODUCT LOGIC
            // =========================================================

            if (isFourOptionStep2Product) {

                let stepOptions;

                // STEP 1
                if (index === 0) {

                    let range = getStepRange(index);

                    stepOptions = options.slice(range.start, range.end + 1);
                }

                // STEP 2 → 4 normal options
                else if (index === 1) {

                    let range = getStepRange(index);

                    stepOptions = options.slice(range.start, range.end + 2);

                    // Remove upload/request fields from step 2
                    stepOptions = stepOptions.filter(function () {

                        let opt = jQuery(this).data('option');

                        return opt !== 'Special Request' &&
                            opt !== 'Pet Image (Big Center Image)' &&
                            opt !== 'Pet Image (Smaller Image) ';
                    });
                }

                // STEP 3 → upload + request fields together
                else if (index === 2) {

                    stepOptions = options.filter(function () {

                        let opt = jQuery(this).data('option');

                        return opt === 'Special Request' ||
                            opt === 'Pet Image (Big Center Image)' ||
                            opt === 'Pet Image (Smaller Image) ';
                    });
                }

                stepOptions.show();

                prevBtn.toggle(index !== 0);

                nextBtn.toggle(index < totalSteps() - 1);

                productForm.toggle(index === totalSteps() - 1);

                updateProgressBar(index);

                return;
            }

            // =========================================================
            // DEFAULT LOGIC
            // =========================================================

            let range = getStepRange(index);

            let stepOptions = options.slice(range.start, range.end + 1);

            // Remove pet options from normal flow ONLY for pet collection
            if (isPetCollection) {

                stepOptions = stepOptions.filter(function () {

                    let opt = jQuery(this).data('option');

                    return opt !== 'pet image' &&
                        opt !== 'Special Request';
                });
            }

            if (index !== 0) {

                stepOptions = stepOptions.filter(function () {

                    return jQuery(this).data('option') !== 'Frame Colour';
                });
            }

            stepOptions.show();

            prevBtn.toggle(index !== 0);

            nextBtn.toggle(range.end < options.length - 1);

            productForm.toggle(range.end >= options.length - 1);

            let frameStyleSelected = jQuery('.cl-po--option[data-option="Frame Style"] select').val();

            let selectFrameColor = jQuery('.cl-po--option[data-option="Frame Colour"]');

            let thickFrameOption = jQuery('.cl-po--option[data-option="Thick Frame"]');

            let petNameOption = jQuery('.cl-po--option[data-option="pet name"]');

            let petImageOption = jQuery('.cl-po--option[data-option="pet image"]');

            let specialRequestOption = jQuery('.cl-po--option').filter(function () {

                return jQuery(this).data('option')?.toLowerCase().includes('special request');
            });

            selectFrameColor.hide();

            thickFrameOption.hide();

            petNameOption.hide();

            petImageOption.hide();

            specialRequestOption.hide();

            if (
                index === 0 &&
                (frameStyleSelected === 'Framed' || frameStyleSelected === 'Frame')
            ) {

                selectFrameColor.show();
            }

            if (index === 1 && frameStyleSelected === 'Canvas') {

                thickFrameOption.show();
            }

            // Final step logic
            if (index === totalSteps() - 1) {

                petNameOption.show();

                // ALWAYS show Special Request
                specialRequestOption.show();

                // ONLY for pet collection
                if (isPetCollection) {
                    petImageOption.show();
                }
            }

            updateProgressBar(index);
        }

        function createProgressBarSteps() {

            progressContainer.empty();

            let steps = totalSteps();

            for (let i = 0; i < steps; i++) {

                progressContainer.append(`
                    <div class="progress-step" data-step="${i}">
                        <div class="step-circle">${i + 1}</div>
                        ${i < steps - 1 ? '<div class="step-line-horizontal"></div>' : ''}
                    </div>
                `);
            }

            options.first().before(progressContainer);
        }

        let navContainer = jQuery('<div class="nav-buttons" style="display:flex; gap:10px; margin-top:10px;"></div>');

        let prevBtn = jQuery(`
            <button id="prevBtn" type="button" class="nav-button" style="display:none;">
                <img src="https://cdn.shopify.com/s/files/1/0520/9758/1215/files/back.png?v=1739793092" width="100%" height="100%" />
            </button>
        `);

        let nextBtn = jQuery('<button id="nextBtn" type="button" class="nav-button" disabled>Next Step</button>');

        navContainer.append(prevBtn, nextBtn);

        options.last().after(navContainer);

        jQuery(document).off('change', '.cl-po--option[data-option="Frame Style"] select');

        jQuery(document).on('change', '.cl-po--option[data-option="Frame Style"] select', function () {

            createProgressBarSteps();

            currentIndex = 0;

            showStep(currentIndex);
        });

        nextBtn.on('click', function () {

            if (currentIndex < totalSteps() - 1) {

                currentIndex++;

                showStep(currentIndex);
            }
        });

        prevBtn.on('click', function () {

            if (currentIndex > 0) {

                currentIndex--;

                showStep(currentIndex);
            }
        });

        jQuery(document).on('lpo:validationFailed', function () {

            nextBtn.prop('disabled', true);
        });

        jQuery(document).on('lpo:validationPassed', function () {

            nextBtn.prop('disabled', false);
        });

        jQuery(document).on('lpo:optionUpdated', function () {

            showStep(currentIndex);
        });

        createProgressBarSteps();

        showStep(0);

        setInterval(function () {

            let hasErrors = jQuery('.cl-po--errors:visible').length > 0;

            nextBtn.prop('disabled', hasErrors);

        }, 500);
    }

    function waitForLPO() {

        let observer = new MutationObserver(function (mutationsList, observer) {

            let optionsExist = jQuery('.cl-po--option').length > 0;

            if (optionsExist) {

                console.log('LPO options detected. Initializing script...');

                observer.disconnect();

                initializeScript();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    waitForLPO();
});

// Observe DOM changes
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {

        // Check added nodes
        mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {

                // If new element contains cl-po--invalid
                if (node.classList && (node.classList.contains('cl-po--invalid') || 
                    node.querySelector('.cl-po--invalid'))) {

                    jQuery(node)
                        .closest('.cl-po--option')
                        .css('display', 'block')
                        .addClass('force-show');
                }
            }
        });

        // Check if class was added to existing node
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if (mutation.target.classList && mutation.target.classList.contains("cl-po--invalid")) {
                jQuery(mutation.target)
                    .closest('.cl-po--option')
                    .css('display', 'block')
                    .addClass('force-show');
            }
        }

    });
});

// Start observing the whole options wrapper
observer.observe(document.body, {
    childList: true,
    attributes: true,
    subtree: true
});


document.querySelectorAll('.product__description').forEach((desc) => {
  const oldText = "UK Delivery: Fast dispatch and delivery via 2nd class Royal Mail.";

  if (desc.innerHTML.includes(oldText)) {
    // Remove the old text wherever it appears
    desc.innerHTML = desc.innerHTML.replaceAll(oldText, '');
    console.log("🗑️ Removed old delivery text from:", desc);
  } else {
    console.log("✅ No old text found in:", desc);
  }
});

document.addEventListener("DOMContentLoaded", function () {

  // ✅ Get UK date parts safely
  function getUKParts() {
    const now = new Date();

    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric"
    }).formatToParts(now);

    const get = (type) => parts.find(p => p.type === type).value;

    return {
      year: +get("year"),
      month: +get("month") - 1,
      day: +get("day"),
      hour: +get("hour"),
    };
  }

  // ✅ Create clean UK date
  function getUKDate() {
    const uk = getUKParts();
    return new Date(uk.year, uk.month, uk.day);
  }

  // ✅ Cutoff logic (same as before)
  function getNextDayOffset() {
    const uk = getUKParts();

    // Before 8 AM → next day
    // After 8 AM → day after tomorrow
    return uk.hour < 8 ? 1 : 2;
  }

  // ✅ Add calendar days (NO weekend skipping)
  function addDays(startDate, daysToAdd) {
    let date = new Date(startDate);
    date.setDate(date.getDate() + daysToAdd);
    return date;
  }

  // ✅ Format date
  function formatDate(date) {
    return date.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: '2-digit',
      month: 'long'
    });
  }

  // ✅ Base UK date
  const ukToday = getUKDate();

  // ✅ Next Day Delivery (calendar days)
  const nextDayDate = addDays(ukToday, getNextDayOffset());
  document.getElementById("next-day").textContent = formatDate(nextDayDate);

  // ✅ Standard Delivery (6 calendar days)
  const standardDate = addDays(ukToday, 5);
  document.getElementById("standard-day").textContent = formatDate(standardDate);

});

jQuery(document).ready(function () {

    setTimeout(function () {

        if (window.location.pathname.indexOf('/products/custom-dog-memorial-photo-collage-print-pet-loss-gift-rainbow-bridge-tribute-personalised-dog-paw-print-poster-pet-remembrance-gift') > -1) {

            if (jQuery('.progress-container').length && !jQuery('.quick-steps-text').length) {

                jQuery('.progress-container').after(
                    '<div class="quick-steps-text">Just 3 quick steps, takes under 2 minutes</div>'
                );

            }

        }

    }, 2000);

});